export default __webpack_public_path__ + "static/media/shoshanim_transparent.16c3b2ff.png";